import { g as i } from "../../utils-BOfnFgIH.js";
import { I as e } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as r, normalizeClass as n, createElementVNode as t, createStaticVNode as d } from "vue";
import { _ as p } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconDialbot",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (o) => Object.keys(e).includes(o)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return e[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = i();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], _ = ["clip-path"], h = ["fill"], u = /* @__PURE__ */ t("path", {
  d: "M17.8 18.5v.8h1.295l-.58-1.158-.715.358Zm-1.121-2.243-.624-.501-.321.4.23.459.715-.358ZM12 7.3a5.2 5.2 0 0 1 5.2 5.2h1.6A6.8 6.8 0 0 0 12 5.7v1.6Zm-5.2 5.2A5.2 5.2 0 0 1 12 7.3V5.7a6.8 6.8 0 0 0-6.8 6.8h1.6Zm5.2 5.2a5.2 5.2 0 0 1-5.2-5.2H5.2a6.8 6.8 0 0 0 6.8 6.8v-1.6Zm5.8 0H12v1.6h5.8v-1.6Zm-1.837-1.085 1.122 2.243 1.43-.716-1.12-2.243-1.432.716ZM17.2 12.5a5.175 5.175 0 0 1-1.145 3.256l1.247 1.002A6.775 6.775 0 0 0 18.8 12.5h-1.6Zm-2 1.6a4.823 4.823 0 0 1-1.491.886 4.816 4.816 0 0 1-3.418 0A4.822 4.822 0 0 1 8.8 14.1v-.8c.295.178.628.33.999.46a7.59 7.59 0 0 0 1.127.313 5.58 5.58 0 0 0 1.077.114c.338 0 .697-.038 1.078-.114a7.59 7.59 0 0 0 1.127-.313c.371-.13.702-.282.992-.46v.8Z",
  fill: "#fff"
}, null, -1), m = ["id"], v = /* @__PURE__ */ d('<stop offset=".06" stop-color="#10022C"></stop><stop offset=".2" stop-color="#611F93"></stop><stop offset=".29" stop-color="#8223A1"></stop><stop offset=".366" stop-color="#9325A5"></stop><stop offset=".459" stop-color="#C52599" stop-opacity=".9"></stop><stop offset=".564" stop-color="#D52C86"></stop><stop offset=".658" stop-color="#EA2F6F"></stop><stop offset=".737" stop-color="#F64850"></stop><stop offset=".896" stop-color="#FD6D2D"></stop><stop offset=".955" stop-color="#FF9E0E" stop-opacity=".95"></stop>', 10), D = [
  v
], b = ["id"], g = /* @__PURE__ */ t("path", {
  fill: "#fff",
  transform: "translate(0 .5)",
  d: "M0 0h24v24H0z"
}, null, -1), I = [
  g
];
function Z(o, S, a, q, A, s) {
  return r(), l("svg", {
    "aria-label": a.ariaLabel,
    class: n([s.iconSizeClass, "d-icon d-icon--dialbot"]),
    "data-qa": s.dataQA,
    "aria-hidden": s.ariaHidden,
    role: "img",
    "data-name": "Dialbot",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    t("g", {
      "clip-path": `url(#${o.uniqueID}a)`
    }, [
      t("path", {
        d: "M12 24.5c6.627 0 12-5.373 12-12S18.627.5 12 .5 0 5.873 0 12.5s5.373 12 12 12Z",
        fill: `url(#${o.uniqueID}b)`
      }, null, 8, h),
      u
    ], 8, _),
    t("defs", null, [
      t("linearGradient", {
        id: `${o.uniqueID}b`,
        x1: "-3.75",
        y1: "-4.675",
        x2: "24.75",
        y2: "24.5",
        gradientUnits: "userSpaceOnUse"
      }, D, 8, m),
      t("clipPath", {
        id: `${o.uniqueID}a`
      }, I, 8, b)
    ])
  ], 10, f);
}
const z = /* @__PURE__ */ p(c, [["render", Z]]);
export {
  z as default
};
//# sourceMappingURL=dialbot.js.map
